import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";

export const getAllLLMModels = async (token) => {
  try {
    const response = await apiFetch(`${backUrl}/llm-models`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching LLM models:", error);
    throw error;
  }
};

export const getActiveLLMModels = async (token) => {
  try {
    const response = await apiFetch(`${backUrl}/llm-models/active`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching active LLM models:", error);
    throw error;
  }
};

export const getLLMModelById = async (token, id) => {
  try {
    const response = await apiFetch(`${backUrl}/llm-models/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching LLM model:", error);
    throw error;
  }
};

export const createLLMModel = async (token, modelData) => {
  try {
    const response = await apiFetch(`${backUrl}/llm-models`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(modelData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating LLM model:", error);
    throw error;
  }
};

export const updateLLMModel = async (token, id, modelData) => {
  try {
    const response = await apiFetch(`${backUrl}/llm-models/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(modelData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating LLM model:", error);
    throw error;
  }
};

export const deleteLLMModel = async (token, id) => {
  try {
    const response = await apiFetch(`${backUrl}/llm-models/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting LLM model:", error);
    throw error;
  }
};
